<template>
  <main>
    <div class="about-wrp content-box fadeInUp">
      <h1 class="about-h1">We’re a web & software<br/> development agency.</h1>
      <p class="about-txt-main">Capital C is a team of multidisciplinary digital product experts focused on branding, UI/UX design, mobile, and advanced web development. Our New York studio is intentionally small, to give each client the attention & focus they need.<br/><br/> Since 2012, we’ve worked with companies that run the gamut from startup businesses to established enterprises. The services provided helped to advance them in the digital world.</p>
    
      <h2 class="about-h2">Expertise</h2>
      <div class="about-exp-txt">
        <p>- UI/UX design </p>
        <p>- Web design</p>
        <p>- Web development</p>
        <p>- App development</p>
        <p>- Cloud based software development</p>
      </div>

      <h2 class="about-h2">Location</h2>
      <div class="about-location">
        <p>United States</p>
        <p>5304 13th Ave, Brooklyn NY, 11204</p>
      </div>
    </div>

    <about-footer
      :background="'#EDEDED'"
      :color="'#161717'"
    />
  </main>
</template>

<script>
import Footer from '../components/footer/Footer'
export default {

  components:{
    AboutFooter:Footer
  }

}
</script>

<style>
.about-wrp{
  padding-top: 3%;
  padding-bottom: 6%;
}

.about-h1{
  font-size: 52px;
  line-height: 62px;
  font-weight: 600;
}

.about-txt-main{
  padding-top: 4%;
  padding-bottom: 6%;
  font-size: 30px;
  line-height: 49px;
  font-weight: 300;
  color: #818181;
}

.about-h2{
  font-size: 35px;
  font-weight: 600;
}

.about-exp-txt{
  font-size: 24px;
  line-height: 48px;
  font-weight: 300;
  color: #818181;
  padding: 2% 0 5% 0;
}

.about-location{
  padding-top: 2%;
  font-size: 30px;
  line-height: 48px;
}

.about-location p:first-child{
  font-weight: 600;
}

.about-location p:last-child{
  font-weight: 300;
  color: #818181;
}

@media screen and (max-width: 1366px){
  .about-h1{
    font-size: 39px;
    line-height: 49px;
  }

  .about-txt-main{
    font-size: 27px;
    line-height: 46px;
  }

  .about-exp-txt{
    font-size: 21px;
    line-height: 45px;
  }

  .about-h2{
    font-size: 31px;
  }

  .about-location{
    font-size: 27px;
    line-height: 45px;
  }
}

@media screen and (max-width: 800px){
  .about-h1{
    font-size: 36px;
    line-height: 46px;
  }

  .about-txt-main{
    font-size: 24px;
    line-height: 43px;
  }

  .about-exp-txt{
    font-size: 18px;
    line-height: 42px;
  }

  .about-h2{
    font-size: 28px;
  }

  .about-location{
    font-size: 25px;
    line-height: 42px;
  }
}

@media screen and (max-width: 589px){
  .about-h1{
    font-size: 33px;
    line-height: 43px;
  }

  .about-txt-main{
    font-size: 21px;
    line-height: 30px;
  }

  .about-exp-txt{
    font-size: 15px;
    line-height: 39px;
  }

  .about-h2{
    font-size: 25px;
  }

  .about-location{
    font-size: 22px;
    line-height: 39px;
  }
}

@media screen and (max-width: 320px){
  .about-h1{
    font-size: 30px;
    line-height: 40px;
  }

  .about-txt-main{
    font-size: 18px;
  }

  .about-exp-txt{
    font-size: 12px;
    line-height: 36px;
  }

  .about-h2{
    font-size: 22px;
  }

  .about-location{
    font-size: 19px;
    line-height: 36px;
  }
}
</style>
